import { GIT_COMMIT_REF, GIT_COMMIT_SHA } from 'env';

export function getRefShaCommit() {
  const refShaCommit = `${GIT_COMMIT_REF}/${GIT_COMMIT_SHA}`;
  return GIT_COMMIT_REF && GIT_COMMIT_SHA ? refShaCommit : 'local';
}
